import DeleteReturnModal from './DeleteReturnModal';
import { withI18n } from 'react-i18next';
export default withI18n()(DeleteReturnModal);
